import { eventListQuerySchema } from '@flux/shared';
import { createRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { JournalPage } from '@/features/journal/journal-page.js';
import { authenticatedRoute } from './authenticated.js';

/**
 * `/journal` — écran Journal (`02` §11). `validateSearch` dérive de
 * `eventListQuerySchema` (`@flux/shared`, source de vérité de
 * `GET /api/events`), étendu de deux paramètres propres à l'écran : `view`
 * pilote l'onglet (Journal / Alertes / Runs) et `store` est l'alias d'URL du
 * filtre « Origine » (`useOriginFilter`).
 *
 * Les trois onglets sont des vues d'une même route, pas des routes séparées :
 * le filtre, la pagination et le tri sont communs.
 */
const journalSearchSchema = eventListQuerySchema.extend({
  view: z.enum(['journal', 'alertes', 'runs']).default('journal'),
  store: z.string().optional(),
});

export const journalRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/journal',
  validateSearch: (search: Record<string, unknown>) => journalSearchSchema.parse(search),
  component: JournalPage,
});
